module.exports = __webpack_public_path__ + "img/spirit_big_4.4aa29755.png";